export const dbFieldMap = {
	id: 'Id',
	name: 'Nome',
	operator: "Operatore",
	group: "Gruppo",
	syncUrl: "Url",
	devName: "Dispositivo",
	path: "Percorso",

};
